import { render, staticRenderFns } from "./CompanyTaining.vue?vue&type=template&id=03f6f1c6&scoped=true"
import script from "./CompanyTaining.vue?vue&type=script&lang=js"
export * from "./CompanyTaining.vue?vue&type=script&lang=js"
import style0 from "./CompanyTaining.vue?vue&type=style&index=0&id=03f6f1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6f1c6",
  null
  
)

export default component.exports